import IndexPage from '@webtv/base-app/IndexPage';
export default IndexPage;